export const StatusDocumento = {
    PENDENTE_ASSINATURA: 1,
    ASSINADO: 2,
    RECUSADO: 3,
    QUARENTENA: 4,
    RETORNADO: 5
};

